<template>
    <div class="bg-grey blogpage">
        <b-container class="pt-100 pb-180 position-relative">
            <b-row>
                <b-col lg="4">
                    <b-row>
                        <b-col lg="12" cols="6">
                            <div class="freight-big-pro-book text-blue fontsize-70" role="heading">
                                The
                                <br>
                                SouthBay
                                <br>
                                <div class="d-flex align-items-center">
                                    Blog <div style="width: 70px; height: 2px; background-color: #0b2340" class="ml-4 mt-3"></div>
                                </div>
                            </div>
                            <div class="freight-big-pro-book h2 mt-80 text-blue">
                                SET YOUR SIGHTS
                                <br>
                                ON WASAGA BEACH
                            </div>
                        </b-col>
                        <b-col lg="12" cols="6">
                            <div class="max-w-300 mt-lg-5 mt-0">
                                <img src="/img/sb-transparent.png" alt="Southbay" class="w-100">
                            </div>
                        </b-col>
                    </b-row>
                    
                </b-col>
                <b-col lg="8" class="overflow-hidden">
                    
                    <b-row class="scrollable-container">
                        <b-col md="6" v-for="(post, i) in blogPosts" :key="i" :class="post.offset" class="mt-reset">
                            <nuxt-link :to="'/blog/' + post.slug" class="post">
                                <div class="border position-relative">
                                    <img :src="post.heroImg" :alt="post.heroImgAlt" class="w-100 d-block">
                                    <div class="p-4">
                                        <div class="h3 freight-big-pro-book text-blue" role="heading" v-html="post.heading"></div>
                                        <div class="acumin-pro-wide-light postdesc text-blue">
                                            {{ post.subheading }}
                                        </div>
                                    </div>
                                    
                                    <div class="acumin-pro-wide-light postdate text-md-right pb-md-3 pr-md-3">
                                        {{ post.date }}
                                    </div>
                                </div>
                            </nuxt-link>
                        </b-col>
                    </b-row>
                </b-col>
                
                <div class="scrolldown">
                    <div class="text">
                        SCROLL
                        <br>
                        DOWN
                    </div>
                    <div class="arrow mx-auto">
                        <img src="/img/arrowdown.png" alt="Arrow Down" class="w-100">
                    </div>
                </div>
            </b-row>
        </b-container>
        <AppFooter />
        <PresentationCenter id="presentation"/>
    </div>
</template>

<script>

import blogPostsData from '@/json/blog'
import AppFooter from '@/components/AppFooter'
import PresentationCenter from '@/components/PresentationCenter'

export default {
    data() {
        return {
            blogPosts: []
        }
    },
    components: {
        AppFooter,
        PresentationCenter
    },
    mounted() {
        this.blogPosts = blogPostsData.data.reverse();
        // this.blogPosts.sort((a, b)=> b.id - a.id);
    }
}
</script>

<style lang="scss">
.blogpage {
    padding-top: 6rem;

    .fontsize-70 {
        font-size: 70px;
        line-height: 110%;

        @media screen and (max-width: 991px) {
            font-size: 40px;
        }
    }

    .scrollable-container {
        max-height: 800px;
        overflow-y: auto;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: -17px;
    }

    .post {
        text-decoration: none;
        color: #0b2340;
    }

    .postdesc {

    }
    
    .postdate {
        // position: absolute;
        // bottom: 15px;
        // right: 15px;
    }

    .mt-reset {
        @media screen and (max-width: 991px) {
            margin-top: 20px;
        }
    }

    .scrolldown {
       
        position: absolute;
        bottom: 15px;
        right: 0;

        .text {
             border: 1px solid #0b2340;
            padding: 0.5rem;
            display: inline-block;
        }

        .arrow {
            max-width: 30px;
        };
    }
}
</style>